import React from 'react';
import { PageHeader, Placeholder } from '../_components/common';

const PlatformAuditLogs = () => (
  <div className="max-w-5xl">
    <PageHeader
      title="Audit Logs"
      subtitle="Append-only record of every privileged action in the API Management subsystem."
    />
    <Placeholder
      icon="ScrollText"
      title="Audit log viewer isn't available yet"
      text="The backend records every super-admin action (consumer/definition create, activate, suspend, revoke, 2FA changes) in an append-only log. A read/query endpoint for it is not implemented yet, so nothing is shown here."
    />
  </div>
);

export default PlatformAuditLogs;
